<template>
  <div>
    <div class="container my-5">
      <h2 class="mb-4 text-center">Shopping Cart</h2>
      
      
      <!-- EMPTY CART MESSAGE -->
      <div v-if="cartItems.length === 0" class="text-center py-5">
        <img src="/images/empty-cart.png" alt="Empty Cart" width="150" class="mb-3" />
        <h4>Your cart is empty</h4>
        <p class="text-muted">Looks like you haven’t added anything yet.</p>
        <button class="btn btn-primary mt-3" @click="$router.push('/')">
          Continue Shopping
        </button>
      </div>

      <div class="row" v-else>
        <!-- Mobile Sticky Checkout Button -->
        <div class="mobile-checkout-bar d-lg-none pb-2">
            <!-- Cart Summary -->
            <div class="col-lg-4">
            <div class="card shadow-sm">
                <div class="card-body">
                <h5 class="mb-3">Order Summary</h5>

                <div class="d-flex justify-content-between mb-2">
                    <span>Subtotal</span>
                    <span>₹3,700</span>
                </div>

                <div class="d-flex justify-content-between mb-2">
                    <span>Shipping</span>
                    <span>₹100</span>
                </div>

                <div class="d-flex justify-content-between fw-bold border-top pt-2">
                    <span>Total</span>
                    <span>₹3,800</span>
                </div>

                <button class="btn btn-cart w-100 mt-4" @click="proceedToCheckout()">
                    <i class="fa fa-shopping-bag me-2"></i> Proceed to Checkout
                </button>
                </div>
            </div>
            </div>
        </div>

        <!-- Cart Items -->
        <div class="col-lg-8">
          <div class="card shadow-sm mb-4">
            <div class="card-body">

              <!-- Cart Item -->
              <div class="cart-item" v-for="cart in cartItems" :key="cart._id">
                <div class="cart-left">
                  <img :src="cart.mainImage" class="cart-img" />

                  <div class="cart-name">
                    <h6>{{ cart.productDetail.name }}</h6>
                    <!--<p>Category • Size M</p>-->
                  </div>
                </div>

                <div class="cart-center">
                  <input type="number" min="1" v-model="cart.qty" class="qty-input" @change="updateCartQty(cart)" />
                  <span class="item-price">₹{{ cart.itemPrice }}</span>
                </div>

                <button class="delete-btn" @click="deleteCartItem(cart._id)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>

            </div>
          </div>
        </div>

        <!-- Cart Summary -->
        <div class="col-lg-4">
          <div class="card shadow-sm">
            <div class="card-body">
              <h5 class="mb-3">Order Summary</h5>

              <div class="d-flex justify-content-between mb-2">
                <span>Subtotal</span>
                <span>₹{{ subTotal }}</span>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <span>Shipping</span>
                <span>₹0</span>
              </div>

              <div class="d-flex justify-content-between fw-bold border-top pt-2">
                <span>Total</span>
                <span>₹{{ subTotal }}</span>
              </div>

              <button class="btn btn-cart w-100 mt-4" @click="proceedToCheckout()">
                <i class="fa fa-shopping-bag me-2"></i> Proceed to Checkout
              </button>
            </div>
          </div>
        </div>

      </div> <!-- row -->
    </div><!-- container -->
  </div>
</template>

<script>
// @ is an alias to /src
import {useToast} from 'vue-toast-notification';
const $toast = useToast();

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import ProductService from "../services/ProductService";
import OrderService from "../services/OrderService";
import { EventBus } from '@/eventBus'

export default {
  name: 'Cart',
  components: {
    VueTelInput
  },
  props: {
  },
  data() {
    return {
      isDisabled: false,
      cartItems: [],
      subTotal: 0,
    };
  },
  methods: {
    getCartItems() {
      ProductService.getCartItems({ slug: this.slug })
        .then((response) => {
          this.cartItems = response.data.data;
          this.subTotal = response.data.subTotal;
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    async updateCartQty(cart) {
        if (cart.qty <= 0) {
            cart.qty = 1;
        }
        let data = {
            cartId: cart._id,
            qty: cart.qty
        }
        await ProductService.updateCartQty(data)
        .then((response) => {
          EventBus.emit('cart-updated')
          $toast.success(response.data.respones_msg);
          this.getCartItems();
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    proceedToCheckout() {
      if (!this.cartItems || this.cartItems.length === 0) {
        this.$toast.error('Your cart is empty');
        return;
      }
      this.$router.push({ name: 'Checkout' });
    },
    async createOrder() {
      let data = {
            amount: 500,
      }
      const response = await OrderService.createOrder(data);
      const order = response.data.data;
      const options = {
        key: process.env.VUE_APP_RAZORPAY_KEY,
        amount: order.amount,
        currency: order.currency,
        name: "Bees Atelier",
        description: "Fixed Payment",
        order_id: order.id,

        handler: async (paymentResponse) => {
          try {
            await OrderService.verifyPayment({
              razorpay_order_id: paymentResponse.razorpay_order_id,
              razorpay_payment_id: paymentResponse.razorpay_payment_id,
              razorpay_signature: paymentResponse.razorpay_signature,
            });
            this.$toast.success("Payment successful");
          } catch (err) {
            this.$toast.error("Payment verification failed");
          }
        },
      };
      const rzp = new Razorpay(options);

      rzp.on("payment.failed", function (response) {
        console.error(response.error);
      });

      rzp.open();
    },
    async deleteCartItem(cartId) {
        let data = {
            cartId: cartId,
        }
        await ProductService.deleteCartItem(data)
        .then((response) => {
          EventBus.emit('cart-updated')
          $toast.success(response.data.respones_msg);
          this.getCartItems();
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
  },
  beforeMount() {
    this.getCartItems();
  },
  created () {
  },
}
</script>
<style scoped>
/* ---------------------------------------
   DESKTOP (unchanged)
----------------------------------------*/
.cart-item {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;
  gap: 15px;
}

/* Left block - image + name */
.cart-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Product image */
.cart-img {
  width: 70px;
  height: 70px;
  border-radius: 8px;
  object-fit: cover;
}

/* Qty + Price */
.cart-center {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Delete Icon */
.delete-btn {
  border: none;
  background: transparent;
  font-size: 20px;
  color: #d9534f;
}

/* Unified Checkout Button Styling */
.btn-cart {
  background: linear-gradient(135deg, rgb(118, 172, 175), rgb(98, 152, 155));
  color: white;
  font-weight: 600;
  border-radius: 30px;
}
/*.btn-cart:hover {
  background: #e66000 !important;
}*/

/* ---------------------------------------
   MOBILE OPTIMIZED LAYOUT
----------------------------------------*/
@media (max-width: 576px) {

  /* Cart card becomes compact */
  .cart-item {
    grid-template-columns: 1fr;
    gap: 5px;
    padding: 12px 8px;
  }

  /* Image + name stays together */
  .cart-left {
    gap: 10px;
  }
  .cart-img {
    width: 55px;
    height: 55px;
  }

  /* Qty + Price + Delete in ONE ROW */
  .cart-center {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-left: 65px; /* aligns with name */
  }

  /* Qty box */
  .qty-input {
    width: 55px !important;
    height: 32px;
  }

  /* Price text */
  .item-price {
    font-size: 15px;
    font-weight: bold;
  }

  /* Delete icon aligned right */
  .delete-btn {
    position: absolute;
    right: 10px;
    margin-top: -25px; /* sits next to qty+price row */
  }

  /* Parent container needs to be positioned */
  .cart-item {
    position: relative;
  }
}

/* Desktop only: make qty box smaller */
@media (min-width: 577px) {
  .qty-input {
    width: 55px !important;   /* Reduce width */
    padding: 4px 6px;         /* Optional: tighter padding */
  }
}

</style>